import { Provider } from '@rollbar/react';
import config from './config';

export const ErrorLoggerProvider = ({ children }: React.PropsWithChildren) => {
  return <Provider config={config}>{children}</Provider>;
};
